export default "__VITE_ASSET__w8A1mErP__"